export default __webpack_public_path__ + "static/media/wordsearch_standard.0432f63e.svg";